import { BlIcon } from '@blend/shared-react';
import { combineStyles, fonts, media, mixins } from '@blend/consumer-components';
import { css, StyleSheet } from 'aphrodite';
import * as React from 'react';

import { Link } from 'react-router';
import * as deploymentConfig from 'login-utils/deploymentConfig';
import { horizontalPadding, mediumViewHorizontalPadding, smallViewTopPadding } from '../Common/PaneLayout/paneStyles';

const loginActionColor = deploymentConfig.getOrganizationColors().action;
const translateKeyframes = {
  '0%': {
    opacity: 0,
    transform: 'translateX(-10px)',
  },
  '100%': {
    opacity: 1,
    transform: 'translateX(0)',
  },
};

const linkStyles = StyleSheet.create({
  forwardArrow: {
    display: 'none',
    [media.largeView]: {
      color: loginActionColor,
      display: 'inline-block',
      marginLeft: 12,
      transform: 'translateX(0px)',
      transition: 'transform .15s ease-out',
    },
  },
  linkWrapper: combineStyles(
    mixins.animate(translateKeyframes, 0.3, 'initial', 'initial'),
    mixins.margin(72, horizontalPadding, 0),
    mixins.transition('background-color', 0.3, 'ease-out'),
    {
      ...fonts.Roboto,
      alignItems: 'center',
      animationDelay: '.5s',
      animationFillMode: 'forwards',
      color: loginActionColor,
      display: 'flex',
      float: 'left',
      fontSize: 14,
      fontWeight: fonts.weight.medium,
      lineHeight: '18px',
      opacity: 0,
      position: 'relative',
      textDecoration: 'none',
      /*
       * Aphrodite child selector hack
       * https://github.com/Khan/aphrodite/issues/10
       */
      ':hover .animateRight': {
        transform: 'translateX(4px)',
      },
      [media.mediumView]: {
        ...mixins.margin(72, mediumViewHorizontalPadding, 0),
      },
      [media.smallView]: {
        float: 'none',
        lineHeight: '18px',
        marginTop: smallViewTopPadding,
        maxWidth: 520,
        position: 'static',
      },
    },
  ),
});

interface Props {
  href: string;
}

const LoginLink: React.SFC<Props> = props => (
  <Link to={props.href} className={css(linkStyles.linkWrapper)}>
    {props.children}
    <div className={`${css(linkStyles.forwardArrow)} animateRight`}>
      <BlIcon icon="date-arrow-right" size="xs" />
    </div>
  </Link>
);

export default LoginLink;
